import { CLASS_NAME, create, append, remove, move } from "."
import {
  getRelativeCoordinates,
  preventOverlaping,
  shiftByPageOffset,
  shiftUnder,
} from "./helpers/coordinates-calculation"
import readBoundaries from "./helpers/read-boundaries"

function createTitle(textContent) {
  const div = document.createElement("div")
  div.className += `${CLASS_NAME}__title`
  div.textContent = textContent
  return div
}

function createTextLine(textContent) {
  const text = document.createElement("p")
  text.className += `${CLASS_NAME}__line`
  text.textContent = textContent
  return text
}

function createInfoTooltip(title, textContent) {
  const tooltip = create()
  tooltip.classList.add("is-info")
  tooltip.appendChild(createTitle(title))
  tooltip.appendChild(createTextLine(textContent))
  return tooltip
}

class InfoTooltip {
  constructor(title, textContent) {
    this.tooltip = createInfoTooltip(title, textContent)
    this.isProcessing = false
    this.inDOM = false
    this.tasks = []
  }

  addTask(task) {
    this.tasks.push(task)

    if (!this.isProcessing) this.run()
  }

  run() {
    if (this.tasks.length === 0) {
      this.isProcessing = false
      return
    }

    this.isProcessing = true
    this.tasks.shift()(() => this.run())
  }

  append(next) {
    if (this.tooltip == null || this.inDOM) {
      next(null)
      return
    }

    this.addTask((done) => {
      append(this.tooltip, document.body, () => {
        this.inDOM = true
        next(null)
        done()
      })
    })
  }

  remove(next) {
    if (this.tooltip == null || !this.inDOM) {
      next(null)
      return
    }

    this.addTask((done) => {
      remove(this.tooltip, () => {
        this.inDOM = false
        next(null)
        done()
      })
    })
  }

  moveTo(el, next) {
    if (this.tooltip == null || !this.inDOM) {
      next(null)
      return
    }

    this.addTask((done) => {
      readBoundaries([this.tooltip, el], ([tooltipRect, elRect]) => {
        const relative = getRelativeCoordinates(elRect)
        const shiftedByPage = shiftByPageOffset(relative)
        const shiftedUnderEl = shiftUnder(elRect, shiftedByPage)
        // console.log(tooltipRect);
        const { x, y } = preventOverlaping(tooltipRect, shiftedUnderEl)

        move(this.tooltip, x, y, () => {
          next(null)
          done()
        })
      })
    })
  }
}

export default InfoTooltip
